function LoadingSpinner() {
    return (
        <div className="loading-screen">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default LoadingSpinner;